import { render, staticRenderFns } from "./DEFAULT_2.vue?vue&type=template&id=72ac2205&"
import script from "./DEFAULT_2.vue?vue&type=script&lang=js&"
export * from "./DEFAULT_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('72ac2205', component.options)
    } else {
      api.reload('72ac2205', component.options)
    }
    module.hot.accept("./DEFAULT_2.vue?vue&type=template&id=72ac2205&", function () {
      api.rerender('72ac2205', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/new/DEFAULT_2.vue"
export default component.exports